export default __webpack_public_path__ + "static/octosign-example1-8bd77b364097e96cbf0f085bc732b3ea.png";